// @ts-nocheck
export const stickyHeaderHeightVariable = "--sticky-header-height";

/**
 * Sticky header height in px, or 0 when the page has no header. Reads scroll-padding-top because the browser
 * resolves it to px; the variable itself can still be in rem (the theme fallback).
 */
const getStickyHeaderHeight = () => {
    return parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
};

export default getStickyHeaderHeight;
